{
	"app": {
		"name": "Medals",
		"fullName": "Medal and Scheduling System",
		"wordmark": "MSES",
		"tagline": "Medal desk"
	},
	"state": {
		"loading": "Loading…"
	},
	"actions": {
		"back": "Back",
		"cancel": "Cancel",
		"close": "Close",
		"confirm": "Confirm",
		"reload": "Reload",
		"retry": "Try again",
		"save": "Save",
		"signOut": "Sign out",
		"showMore": "Show more"
	},
	"shell": {
		"continueAs": "Continue as {{role}}",
		"gamesLogo": "SEA Games 2027",
		"noActiveRole": "No active role",
		"signedInAs": "Signed in as {{role}}",
		"skipToContent": "Skip to content",
		"switchRole": "Switch role"
	},
	"roles": {
		"SUPER_ADMIN": "Super Admin",
		"ADMIN": "Admin",
		"MEDAL_DESK": "Medal desk",
		"OPERATION": "Operation",
		"ORGANIZATION": "Organization",
		"TRANSPORT_PROVIDER": "Transport provider",
		"HOTEL": "Hotel",
		"WORKFORCE": "Workforce",
		"PARTICIPANT": "Participant",
		"PUBLIC": "Public"
	},
	"resultStatus": {
		"NONE": "No result",
		"START_LIST": "Start list",
		"LIVE": "Live",
		"UNOFFICIAL": "Unofficial",
		"OFFICIAL": "Official"
	},
	"eventGender": {
		"MEN": "Men",
		"WOMEN": "Women",
		"MIXED": "Mixed",
		"OPEN": "Open"
	},
	"notFound": {
		"title": "Page not found",
		"body": "This address does not match any screen in MSES.",
		"home": "Go to the medal desk"
	},
	"routeError": {
		"title": "This screen could not load",
		"unreachable": "Can't reach the server",
		"requestId": "Request ID"
	},
	"session": {
		"checking": "Checking your session…",
		"checkingNow": "Trying again…",
		"unreachableBody": "Your work on this device is kept. Retrying automatically — the app opens as soon as the server answers.",
		"nextTry": "Next try in {{seconds}} s",
		"tryNow": "Try now"
	},
	"noAccess": {
		"title": "No access to the medal desk",
		"body": "MSES is for the medal desk only. Ask an administrator to give your account the Medal desk role.",
		"reasonRole": "The {{role}} role does not award medals: only the Medal desk role does.",
		"reasonNoRole": "Your account has no active role."
	},
	"time": {
		"inZone": "{{time}} ({{zone}})"
	},
	"ui": {
		"dataTable": {
			"action": "Action",
			"errorTitle": "Couldn't load this list",
			"tryAgain": "Try again",
			"emptyTitle": "Nothing here yet",
			"selected": "selected",
			"onOtherPages": "{{n}} on other pages",
			"clear": "Clear",
			"columns": "Columns",
			"showColumns": "Show columns",
			"always": "always",
			"showAll": "Show all",
			"hiddenCount": "{{n}} hidden",
			"selectRow": "Select row {{row}}",
			"selectAllRows": "Select all rows on this page",
			"deselectAllRows": "Deselect all rows on this page"
		},
		"pagination": {
			"label": "Pagination",
			"summary_one": "{{from}}–{{to}} of {{total}} result",
			"summary_other": "{{from}}–{{to}} of {{total}} results",
			"summaryWithNoun": "{{from}}–{{to}} of {{total}} {{noun}}",
			"empty": "No results",
			"emptyWithNoun": "No {{noun}}",
			"rowsPerPage": "Rows per page",
			"firstPage": "First page",
			"previousPage": "Previous page",
			"nextPage": "Next page",
			"lastPage": "Last page",
			"page": "Page {{page}}"
		},
		"select": {
			"placeholder": "Select…",
			"searchPlaceholder": "Search…",
			"noMatches": "No matches",
			"clear": "Clear",
			"removeOption": "Remove {{label}}",
			"selectedCount": "{{n}} selected",
			"selectAll": "Select all"
		},
		"filterBar": {
			"label": "Filters",
			"apply": "Filter",
			"reset": "Reset"
		},
		"modal": {
			"close": "Close"
		}
	}
}
